import React from "react";
import ShopCategory from "./[category]";
import PreferencesForYou from "components/Home/setPreferencesForYou";
import ParentScrollView from "components/ParentScrollView";
import { useSelector } from "react-redux";
const ForYou = () => {
    const homeData = useSelector((state) => state.HomeReducer.homeData);
    const ForYou = homeData?.filter(item => item?.optionName === "For You");        
    const lengthForYou = (ForYou.length) ? ForYou?.[0]?.products?.length : 0;
    if(lengthForYou == 0){
        return <ParentScrollView><PreferencesForYou /></ParentScrollView>;
    }
    return <ShopCategory />;
};

export default ForYou;
